import {
  EEquipmentPhysicalTypeCategory,
} from '@/types/equipment.ts';

const category: Record<EEquipmentPhysicalTypeCategory, string> = {
  [EEquipmentPhysicalTypeCategory.BATCH_FURNACE]: 'Vsádzkové pece',
  [EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE]: 'Poloplynulé pece',
  [EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE]: 'Plynulé pece',
  [EEquipmentPhysicalTypeCategory.STORAGE]: 'Sklad',
};

export default {
  placeholder: 'Vybrať fyzický typ zariadenia',
  category,
};
